((w) => {
    const utils = new GtmUtils();
    var externalTrackingSystemName = 'gtm';

    if (w.ExternalTrackingEventBus) {
        w.ExternalTrackingEventBus.register(externalTrackingSystemName);
    }

    w.PubSub.subscribe('externaltracking.shoppinglist', (topic, data) => {
        const channelParts = topic.split('.');
        const topicAction = channelParts[channelParts.length - 1];
        var topicActionLowerCase = topicAction.toLowerCase();
        const currencyCode = utils.getCurrencyCode();

        const mapConvertItems = (items) => items.map(trackableShoppingListEntry =>
            utils.convertToGtmGa4Product(trackableShoppingListEntry.product, {
                'quantity': trackableShoppingListEntry.quantity
            }));

        try {
            switch (topicActionLowerCase) {
                case 'addtowishlist':
                    var gtmAddProducts = mapConvertItems(data.items);
                    pushGtmEvent('add', gtmAddProducts, data.source);
                    break;
                default:
                    throw 'Unknown shoppinglist action received via pubsub: ' + topicAction;
            }

        } catch (e) {
            console.error('[GTM]: Failed to push cart changes to dataLayer. Reason: ' + e);
        }
        finally {
            if (w.ExternalTrackingEventBus) {
                w.ExternalTrackingEventBus.eventHandled(externalTrackingSystemName, topicActionLowerCase, data);
            }
        }

        function pushGtmEvent(type, products, source) {
            var gtmEvent;
            switch (type) {
                case 'add':
                    gtmEvent = {
                        'event': 'add_to_wishlist',
                        'ecommerce': {
                            'currency': currencyCode,
                            'items': products
                        }
                    };
                    break;
                default:
                    throw 'Unknown GtmEvent type: ' + type;

            }

            w.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
            w.dataLayer.push(gtmEvent);

            if (source === 'callback') {
                w.PubSub.publish('externaltracking.complete');
            }
        }
    });
})(window);